<template>
  <div class="q-pa-sm">
    <task-queues
      :options="options"
      @select="onRowDblClick"
    />
  </div>
</template>

<script>
// Vuex
import { mapMutations } from 'vuex'

// Components
import TaskQueues from '../../components/queue/TaskQueues.vue'

export default {
  name: 'PickingQueues',
  components: {
    TaskQueues
  },
  computed: {
    options () {
      return {
        type: 'routed_discrete',
        title: 'Picking by order ID',
        service: this.$service.pickingQueue,
        settings: true,
        adapters: ['routed_discrete', 'discrete']
      }
    }
  },
  methods: {
    ...mapMutations([
      'setPickingQueue'
    ]),
    onRowDblClick ({ item, toFilters }) {
      this.setPickingQueue(item)
      const path = `/workstation/queues/picking/entity/${item.id}${toFilters ? '?start=true' : ''}`
      this.$router.push(path)
    }
  }
}
</script>
